export const emptyPurchaseOrderStagingItem = () => ({
  item_type: 'product',
  product_id: '',
  service_id: '',
  unit_of_measure: '',
  project_id: '',
  quantity: 1,
  unit_price: 0,
  has_igv: true,
});

export const emptyVentasServiceItem = () => ({
  item_type: 'service',
  product_id: '',
  service_id: '',
  description: '',
  unit_of_measure: '',
  project_id: '',
  quantity: 1,
  unit_price: '',
  has_igv: true,
});

export const emptyRequirementStagingItem = () => ({
  product_id: '',
  quantity: '',
  unit_of_measure: '',
  project_id: '',
  notes: '',
});

export const emptyDocumentProductStagingItem = (igvRate = 18) => ({
  item_type: 'product',
  product_id: '',
  service_id: '',
  unit_of_measure: '',
  project_id: '',
  description: '',
  quantity: 1,
  unit_price: 0,
  has_igv: true,
  subtotal: 0,
  tax_rate: igvRate,
  tax_amount: 0,
  total: 0,
  is_direct_consumption: false,
});

export const emptyGuideStagingItem = ({ isInitial, isExit, isTransfer, isReception }) => ({
  product_id: '',
  description: '',
  project_id: '',
  kardex_event: isInitial
    ? 'saldo_inicial'
    : isExit
      ? 'venta'
      : isTransfer
        ? 'traspaso'
        : isReception
          ? 'recepcion'
          : 'compra',
  quantity: 1,
  unit_price: 0,
  total: 0,
  unit_of_measure: '',
  condition: 'good',
  has_igv: true,
});
